



export interface SouscriptionProgressJSON {
    steps : SouscriptionStepProgress[];
    hasCoborrower: boolean;
    currentStepDescription: string;
    paymentEstimatedDate? : string;  // 'yyyy-MM-dd'
    loanEndEstimatedDate? : string;  // 'yyyy-MM-dd'
}


export interface SouscriptionStepProgress {
    stepCode: SouscriptionStepCode;
    title: string;
    enabled: boolean;
    stepStatus: SouscriptionStepStatus;   // indique si c'est une étape passée, courante, échec...
    globalStepContent?: SouscriptionStepProgressContent;   // contenu global
    borrowerStepContent?: SouscriptionStepProgressContent;
    coBorrowerStepContent?: SouscriptionStepProgressContent;
}

export interface SouscriptionStepProgressContent {
    status : SouscriptionStepStatus;
    type : SouscriptionStepType;

    // for type SIGNATURE_ACTION or URL_TAB_ACTION
    actionURL : string;  // URL
    actionTitle : string; // button title

    // for type MESSAGE
    title : string;
    highlightedText : string;
}

export enum SouscriptionStepCode {
    FILE_COMPLETED = 'FILE_COMPLETED',
    PLEDGE_CONTRACT_SIGNATURE = 'PLEDGE_CONTRACT_SIGNATURE',
    PRE_ACCEPTATION = 'PRE_ACCEPTATION',
    LOAN_CONTRACT_SIGNATURE = 'LOAN_CONTRACT_SIGNATURE',
    LENDER_PROOF_DOCUMENT_DEPOSIT = 'LENDER_PROOF_DOCUMENT_DEPOSIT',
    PLEDGE_VALIDATION = 'PLEDGE_VALIDATION',
    FUND_RELEASED = 'FUND_RELEASED',
}

export enum SouscriptionStepStatus {
    FAILED = 'FAILED',      // orange cross icon
    SUCCESS = 'SUCCESS',    // green checkmark icon
    CURRENT = 'CURRENT',    // hourglass icon
    PENDING = 'PENDING',    // hourglass icon
    NONE = 'NONE'
}

export enum SouscriptionStepType {
    NONE ='NONE',
    SIGNATURE_ACTION = 'SIGNATURE_ACTION',
    URL_TAB_ACTION = 'URL_TAB_ACTION',
    ICON = 'ICON',
    MESSAGE = 'MESSAGE',
}

